// 通用接口
import { get, post } from './request';

// 获取腾讯云临时密钥
const GetCosSignPath = '/api/v1/auth/cosSign';
export const getCosSign = () => get(GetCosSignPath);

// 修改发送消息接口，支持传入 chatId
export const sendMessage = (data: {
  message: string;
  chatId?: string;
  model: string;
}) => post('/api/v1/chat', data); 
